import { isObject } from "@pineapplelab/util";
import { FBase } from "./FBase";
import { Chapter } from "./chapter";
import { IsNotEmpty } from "@pineapplelab/validators";
import { Language } from "../utils/language";
import { TranslationStatusEnum } from "../enums/translationStatus.enum";

export class LanguageCourse extends FBase {

	@IsNotEmpty({ label: "Language" })
	language: Language = null;
	name: string = null;
	description: string = null;
	keywords: string[] = [];
	duration: number = 0;
	chapters: Chapter[] = [];
	isDefault: boolean = false;
	active: boolean = false;
	nameLowercase: string = null;
	translationStatus: TranslationStatusEnum = null;

	__isFullCourseTranslated: boolean = true;
	__removedChapters: { id: string }[] = [];

	constructor(json?: { [key: string]: any }) {
		super();
		if (isObject(json)) {
			this.fromJson(json);
		}
	}
}
export namespace LanguageCourse {
	export const PATH = 'languageCourses';
}
